"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const computeComplexUnit_1 = __importDefault(require("../ControlStyleFormaters/shared/computeComplexUnit"));
const controlFontSizeCompute_1 = __importDefault(require("./controlFontSizeCompute"));
const controlStyleToAtomStyle = ({ globalFontSize, getColorFromSpecification, style, }) => {
    var _a;
    const transformedStyles = {
        width: (0, computeComplexUnit_1.default)(style.width),
        minWidth: (0, computeComplexUnit_1.default)(style.width),
        maxWidth: (0, computeComplexUnit_1.default)(style.width),
        height: style.heightAuto ? 'auto' : (0, computeComplexUnit_1.default)(style.height),
        maxHeight: style.heightAuto ? undefined : (0, computeComplexUnit_1.default)(style.height),
        minHeight: style.heightAuto ? 'auto' : (0, computeComplexUnit_1.default)(style.height),
        marginRight: (0, computeComplexUnit_1.default)(style.marginRight),
        backgroundColor: (_a = getColorFromSpecification(style.backgroundColor)) !== null && _a !== void 0 ? _a : getColorFromSpecification(style.background),
        marginBottom: (0, computeComplexUnit_1.default)(style.marginBottom),
        marginLeft: (0, computeComplexUnit_1.default)(style.marginLeft),
        marginTop: (0, computeComplexUnit_1.default)(style.marginTop),
        shadowColor: (0, ts_validators_1.valueIsString)(style.shadowColor)
            ? style.shadowColor
            : getColorFromSpecification(style.shadowColor),
        borderColor: getColorFromSpecification(style.borderColor),
        color: getColorFromSpecification(style.color),
        fontSize: (0, controlFontSizeCompute_1.default)({
            globalFontSize,
            fontSize: style.fontSize,
        }),
        placeHolderColor: getColorFromSpecification(style.placeHolderColor),
    };
    const baseStyle = Object.assign(Object.assign({}, style), transformedStyles);
    delete baseStyle.background;
    if (baseStyle.position === 'relative') {
        delete baseStyle.top;
        delete baseStyle.right;
        delete baseStyle.left;
        delete baseStyle.bottom;
    }
    return baseStyle;
};
exports.default = controlStyleToAtomStyle;
